import { Box, TextField, Typography } from "@mui/material";
import SubmitButton from "../../../UI/SubmitButton";
import EntryButton from "../../../UI/EntryButton";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "../../../store/modalSlice";
import { useTranslation } from "react-i18next";
import { createCategoryAction } from "../../../asyncActions/productAction";
import { branchCreateAction, branchToogleArchiveAction, branchUpdateAction } from "../../../asyncActions/branchActions";

function BranchEditContent({ type }) {
    const { t } = useTranslation()

    const dispatch = useDispatch()

    const {
        data
    } = useSelector(store => store.modal)

    const { isArchived, branchData } = data

    const submitHandle = async () => {
        const modalPayload = {
            active: true,
            content: 'action',
            data: {
                text: `Branch was ${type === 'edit' ? 'edited' : 'created '}!`,
                path: '/branches'
            }
        }
        if (type === 'edit') {
            dispatch(branchUpdateAction(data))
        } else if (type === 'create'){
            dispatch(branchCreateAction(data))
        }
        dispatch(setModal(modalPayload))
    }

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '15px',
            width: '450px'
        }}>
            <Typography variant="h6">Did u want to {type === 'edit'? 'edit' : 'create'} branch?</Typography>
            <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                <EntryButton type='button' onClick={() => dispatch(setModal({ active: false }))}>{t('button.cancel')}</EntryButton>
                <SubmitButton onClick={submitHandle} type='submit'>{t('button.submit')}</SubmitButton>
            </Box>

        </Box>
    )
}


export default BranchEditContent
